import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface AvatarDashBorderProps {
  color?: string;
}

/*
 * Style.
 */

interface AvatarDashBorderStyleProps {
  $color?: string;
}
const StyledBorderDiv = styled.div<AvatarDashBorderStyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  border: 1px dashed ${(p) => p.$color || p.theme.greys.shade60};
  border-radius: 50%;
`;

/*
 * Component.
 */

export const AvatarDashBorder: FC<AvatarDashBorderProps> = (props) => (
  <StyledBorderDiv $color={props.color} />
);
